// @flow
import type {Node} from 'react';
import {Box, Typography, Skeleton} from '@wellstone-solutions/web';
import {pluralize as pluralizeUtil} from 'utils/Utils';

type PropsType = {
  isLoading: boolean,
  label: string,
  count: number,
  pluralize?: boolean,
};

export const RowCount = ({
  isLoading,
  label,
  count,
  pluralize = true,
}: PropsType): Node => {
  return (
    <Box sx={{mb: 1}}>
      {isLoading ? (
        <Skeleton variant="text" width="175px" />
      ) : (
        <Typography variant="body2">
          Showing {count} {pluralize ? pluralizeUtil(label, count) : label}
        </Typography>
      )}
    </Box>
  );
};
